// Auto-generated normalizer for table: UnidadesOrg_Empleado
export function unidadesOrgEmpleadoNormalize(row) {
  return {
    idUnidadOrgEmpleado: row.idUnidadOrgEmpleado ?? row.IdUnidadOrgEmpleado ?? row['idUnidadOrg_Empleado'] ?? row['IdUnidadOrg_Empleado'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? row['IdUnidadOrganizacional'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
